module.exports = __webpack_public_path__ + "img/yansheng.4efbdc01.jpg";